export const STORYBLOK_ACCESS_TOKEN = import.meta.env.VITE_STORYBLOK_ACCESS_TOKEN || ''

export const isStoryblokEnabled = Boolean(STORYBLOK_ACCESS_TOKEN) && (import.meta.env.DEV || import.meta.env.MODE === 'testing')
